export default __webpack_public_path__ + "static/media/gaelens.c7fdc5ee.svg";